import React, { createContext, useContext, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

const LoaderContext = createContext();

export const useGlobalLoader = () => useContext(LoaderContext);

export const GlobalLoaderProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const showLoader = () => setOpen(true);
  const hideLoader = () => setOpen(false);

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.modal + 1000,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </LoaderContext.Provider>
  );
};
